import { FC } from 'react'
import { Layout } from 'plotly.js'
import Plot from 'react-plotly.js'
import { IProps } from './types'
import { StyledPlotlyChartContainer, PlotlyStyles } from './index.styles'

const CustomizedPlot: FC<IProps> = (props) => {
    const setPlotProps = (props: IProps) => {
        const textColor = '#1C1E21'
        const backgroundColor = '#FFFFFF'

        const layout: Partial<Layout> = {
            title: {
                text: ((props as any)?.layout?.title as any)?.text ?? '',
                x: 0.5,
                xanchor: 'center',
                font: {
                    color: textColor,
                    size: 16,
                },
            },
            modebar: {
                remove: ['select2d', 'lasso2d', 'autoScale2d', 'toImage'],
            },
            dragmode: false,
            paper_bgcolor: backgroundColor,
            plot_bgcolor: backgroundColor,
            font: {
                color: textColor,
            },
            xaxis: {
                tickfont: { color: textColor },
                title: { font: { color: textColor } },
            },
            yaxis: {
                tickfont: { color: textColor },
                title: { font: { color: textColor } },
            },
        }

        return { ...props, layout: { ...((props as any).layout || {}), ...layout }, useResizeHandler: true }
    }

    return (
        <>
      <PlotlyStyles />
      <StyledPlotlyChartContainer className="plotly-chart-container">
        <Plot {...(setPlotProps(props) as any)} />
      </StyledPlotlyChartContainer>
    </>
    )
}

export default CustomizedPlot
